import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { SharedProgrammingService, CommonProgrammingContext } from './../../../common/services/shared-programming.service';
import { ScheduleQuickstartContext } from './../services/schedule.service';
import { ScheduleProgrammingService, ScheduleEvent } from '../services/schedule.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { EVENTS_FILTER } from '../../events/eventsUI.service';

@Component({
  selector: 'prg-list-by-date',
  templateUrl: './list-by-date.component.html',
  styleUrls: ['./list-by-date.component.less']
})
export class ListByDateComponent extends BaseRoutingComponent implements OnInit {

  scheduleEvents: Observable<ScheduleEvent[]>;
  ready: Observable<boolean>;
  initialized: Observable<boolean>;
  searchText: Observable<string>;
  expanded: Observable<boolean>;

  @Input() creatorFilter: EVENTS_FILTER;

  constructor(
    protected router: Router,
    private shared: SharedProgrammingService,
    private schedule: ScheduleProgrammingService,
    private route: ActivatedRoute,
    protected store: Store<{ sharedProgramming: CommonProgrammingContext, scheduleProgramming: ScheduleQuickstartContext }>
  ) {
    super();

    this.scheduleEvents = this.schedule.scheduleEvents;
    this.ready = this.shared.isReady;
    this.initialized = this.schedule.initialized;
    this.searchText = this.shared.searchText;
    this.expanded = this.shared.listExpanded;
  }

  ngOnInit() {
    this.shared.clearError();
    this.shared.setGrouping('scheduled');
    this.schedule.refresh();
  }

  private toggleExpand() {
    this.shared.toggleListExpanded();
  }

  private tileClicked(item: any) {
    console.log('tile clicked: ', item);
    if (item) {
      this.router.navigate(['when-then/device', item.deviceId, 'event', item.eventId, 'edit'], { relativeTo: this.moduleRoot });
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/list-by-date/list-by-date.component.ts